<template>
  <b-modal
    id="confirmation"
    centered
    hide-footer
    hide-header
    size="lg"
    @hidden="close"
    :visible="true"
  >
    <b-container>
      <b-row v-show="loading">
        <b-col class="text-center">
          <img alt="Processing..." :src="processingGIF" />
        </b-col>
      </b-row>
    </b-container>
    <template v-if="popUpToMatch && needsCustomerMatch()">
      <div :class="{'hidden': loading}">
        <CustomerMatch :set-global-loading="false" @verifying="onCustomerVerifying" v-on:done="updateInputState" :get-cart="false" @fail="onCustomerMatchFailed"></CustomerMatch>
        <div class="bottom-offset"></div>
      </div>
    </template>
    <template v-else-if="popUpToMatch && needsCustomerVerification()" :class="{'hidden': loading}">
      <div :class="{'hidden': loading}">
        <CustomerVerify :set-global-loading="false" @verifying="onCustomerVerifying" @done="updateInputState" :get-cart="false" @fail="onCustomerMatchFailed"></CustomerVerify>
        <div class="bottom-offset"></div>
      </div>
    </template>
    <template v-if="!popUpToMatch" :class="{'hidden': loading}">
      <div class="welcome">
         <h2 class="title">HOW WOULD YOU LIKE TO CONTINUE?</h2>
      </div>
      <b-row :class="{'hidden': loading}" class="flex-column align-items-center my-5">
        <b-col cols="12" md="8" lg="6" class="my-1">
          <b-button @click="continueAsGuest" class="choice-btn btn-success btn-back text-nowrap" variant="primary">Continue as Guest</b-button>
        </b-col>
        <b-col cols="12" md="8" lg="6" class="my-1">
          <b-button class="choice-btn btn-success btn-back text-nowrap" variant="primary" @click="matchCustomer" size="lg">Existing Customer
          </b-button>
        </b-col>
      </b-row>
    </template>
    <b-link block class="centered-block close-button" variant="secondary" @click="close($event)">&times;</b-link>
  </b-modal>
</template>

<script>
import {InputState} from '../constants'
import {mapGetters} from 'vuex'
const CustomerMatch = () => import('../components/CustomerMatch')
const CustomerVerify = () => import('../components/CustomerVerify')

export default {
  name: 'CheckoutCustomerConfirmation',
  components: {
    CustomerMatch,
    CustomerVerify
  },
  data: function() {
    return {
      popUpToMatch: false,
      inputState: InputState.Unknown,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['canLogoutSession', 'isSessionUserKnown', 'processingGIF'])
  },
  methods: {
    needsCustomerMatch: function() {
      return (this.inputState === InputState.NeedsMatch)
    },
    needsCustomerVerification: function() {
      return (this.inputState === InputState.NeedsVerification)
    },
    continueAsGuest: function() {
      this.$bvModal.hide('confirmation')
      this.$emit('verified')
    },
    close: function(e) {
      e.stopPropagation && e.stopPropagation()
      this.$bvModal.hide('confirmation')
      this.$emit('close')
    },
    matchCustomer: function(e) {
      e.stopPropagation()
      this.popUpToMatch = true
      if (this.needsCustomerVerification()) {
        this.inputState = InputState.NeedsVerification
      } else {
        this.inputState = InputState.NeedsMatch
      }
    },
    updateInputState: function() {
      let inputState = InputState.NeedsMatch
      if (this.needsCustomerMatch()) {
        this.$store.commit('ready')
        inputState = InputState.NeedsVerification
      }
      if (this.isSessionUserKnown) {
        this.$store.commit('ready')
        inputState = InputState.OkToSubmit
        this.$bvModal.hide('confirmation')
        this.$emit('verified')
        this.$store.commit('set_cart_state', false)
      }
      this.inputState = inputState
    },
    onCustomerMatchFailed: function(message) {
      this.$emit('verificationFailed', message)
    },
    onCustomerVerifying: function(verifying) {
      this.loading = verifying
    }
  },
  created: function() {
    if (this.canLogoutSession && !this.isSessionUserKnown) {
      this.popUpToMatch = true
      this.inputState = InputState.NeedsVerification
    } else if (this.isSessionUserKnown) {
      this.$bvModal.hide('confirmation')
      this.$emit('verified')
    }
  }
}
</script>

<style scoped>
.hidden {
  display: none !important;
}
.bottom-offset {
  padding-bottom: 52px;
}
.close-button {
  height: 40px !important;
}
</style>
